export default {
  viewFullscreen: 'مشاهده تمام صفحه',
  exitFullscreen: 'خروج از تمام صفحه',
  showMyLocation: 'نمایش موقعیت من',
  removeSelectedPoint: 'حذف نقطه انتخاب شده',
  removeSelectedPoints: 'حذف نقاط انتخاب شده',
  showPlansOnMap: 'نمایش طرح ها روی نقشه',
  hidePlansOnMap: 'عدم نمایش طرح ها روی نقشه',
  chooseThisPointAs_: 'انتخاب این نقطه به عنوان {title}',
  coordinates: 'مختصات',
  submit_: 'تایید {title}',
  extractingAddress: 'در حال استخراج آدرس ...',
  newDestination: 'مقصد جدید',
  theSelectedCoordinatesAreWithinThe_:
    'مختصات انتخاب شده در محدوده {title} قرار دارد',
  position: 'موقعیت',
  leaflet: 'لیفلت',
  defaultLatitude: 'عرض جغرافیایی پیشفرض',
  defaultLongitude: 'طول جغرافیایی پیشفرض',
  defaultZoom: 'بزرگنمایی پیشفرض',
  defaultTheme: 'تم پیشفرض',
  markerPrimaryColor: 'رنگ اصلی مارکر',
  markerSecondaryColor: 'رنگ ثانویه مارکر',
  scrollZoom: 'بزرگنمایی با اسکرول',
  minZoom: 'حداقل بزرگنمایی',
  maxZoom: 'حداکثر بزرگنمایی',
  rtlUrl: 'آدرس RTL',
  styleUrlLight: 'تم نقشه روشن',
  styleUrlDark: 'تم نقشه تاریک',
  styleUrlSat: 'تم نقشه ماهواره',
  apiKey: 'Api key',
  light: 'روشن',
  dark: 'تاریک',
  satellite: 'ماهواره ای',
  extractingPointInfo: 'در حال استخراج اطلاعات جغرافیایی ...'
}
